import { UtcDate } from '@/helpers/date';

export default {
  computesRequired: true,
  validate: (value, { additional = false, dateOfBirth, bornInUk = false }) => {
    let valid = true;

    if (!bornInUk && !value) {
      return {
        valid: false,
        required: true,
      };
    };

    const dateOfUkResident = new UtcDate(value);
    const birthDate = new UtcDate(dateOfBirth);

    if (
      !dateOfUkResident.isValid() ||
      (!dateOfBirth || !birthDate.isValid()) ||
      dateOfUkResident.isBefore(dateOfBirth)
    ) valid = false;

    return {
      valid,
      required: !bornInUk,
    };
  },
  params: ['dateOfBirth', 'additional', 'bornInUk'],
  message (fieldName, { _value_: v, dateOfBirth, additional = false }) {
    const userType = additional ? this.constants.VEHICLE_ADDITIONAL_DRIVER_TYPE : 'you';

    if (!v) return `Please select the date ${userType} became a UK resident.`;
    const dateOfUkResident = new UtcDate(v);
    const birthDate = new UtcDate(dateOfBirth);
    const todayUtc = new UtcDate();
    if (!dateOfUkResident.isValid()) return 'Invalid format for the date of UK resident.';
    if (!dateOfBirth || !birthDate.isValid()) return 'Please select the date of birth at first.';
    if (dateOfUkResident.isBefore(birthDate)) return 'The date of UK resident should not be earlier than date of birth.';
    if (dateOfUkResident.isAfter(todayUtc)) return 'The date of UK resident should not be in future.';

    return `Please select the date ${userType} became a UK resident.`;
  },
};
